{
  "collapse": "Sakļaut",
  "expand": "Izvērst"
}
